import { css, html, LitElement } from 'lit'
import { property } from 'lit/decorators.js'
import { safeCustomElement } from '@/utilities/custom-element'
@safeCustomElement('mdc-key-highlights-section')
export class MdcKeyHighlightsSection extends LitElement {
  @property({ type: String }) risingThisWeek = ''
  @property({ type: String }) totalProfileViews = ''
  @property({ type: String }) newFavorites = ''
  @property({ type: String }) directInquiries = ''

  static styles = css`
    :host {
      display: block;
    }

    .mdc-key-highlights-section {
      display: flex;
      flex-direction: column;
      gap: var(--spacing-075, 0.75rem);
    }

    .mdc-key-highlights-section__title {
      font-family: var(--typography-font-family-sans);
      font-size: var(--typography-font-size-112-and-half);
      font-weight: 600;
      line-height: 1.3;
      letter-spacing: -0.00563rem;
      color: var(--color-functional-gray-black);
      margin: 0;
    }
  `

  render() {
    return html`
      <div class="mdc-key-highlights-section">
        <h2 class="mdc-key-highlights-section__title">Key Highlights</h2>
        <mdc-stats-group textAlign="left" size="lg">
          <mdc-stat
            icon="trend-up"
            value=${this.risingThisWeek}
            label="Rising this week"
          ></mdc-stat>
          <mdc-stat
            icon="eye"
            value=${this.totalProfileViews}
            label="Total profile views"
          ></mdc-stat>
          <mdc-stat icon="heart" value=${this.newFavorites} label="New Favorites"></mdc-stat>
          <mdc-stat
            icon="link"
            value=${this.directInquiries}
            label="Direct inquiries"
          ></mdc-stat>
        </mdc-stats-group>
      </div>
    `
  }
}
